// src
import { hydrateSlice } from "actions/system";
import * as actions from "actions/ux";
import { DAY, MAX_LARGE_WIDTH, MAX_SMALL_WIDTH, MAX_X_SMALL_WIDTH } from "config/constants";
import { buildStorageAdapters } from "utils/storage";
import i18n, { changeLanguage } from "i18n/proxy";

const maxAge = DAY;
const whitelist = ["language"];
const [hydrate, save] = buildStorageAdapters("ux", { maxAge, whitelist });

const updateSizes = () => ({
  isLarge: window.innerWidth >= MAX_LARGE_WIDTH,
  isSmall: window.innerWidth <= MAX_SMALL_WIDTH,
  isXSmall: window.innerWidth <= MAX_X_SMALL_WIDTH,
});

const DEFAULT_STATE = {
  isSearchOpen: false,
  isFavoritesOpen: false,
  language: i18n.language,
  ...updateSizes(),
};

export default (state = DEFAULT_STATE, { type, payload }) => {
  // order actions by frequency
  switch (type) {
    case actions.windowResize.toString(): {
      return {
        ...state,
        ...updateSizes(),
      };
    }
    case actions.showSearch.toString(): {
      return { ...state, isSearchOpen: true, isFavoritesOpen: false };
    }
    case actions.hideSearch.toString(): {
      return { ...state, isSearchOpen: false };
    }
    case actions.showFavorites.toString(): {
      return { ...state, isFavoritesOpen: true, isSearchOpen: false };
    }
    case actions.hideFavorites.toString(): {
      return { ...state, isFavoritesOpen: false };
    }
    case actions.setLanguage.toString(): {
      changeLanguage(payload);
      return save({ ...state, language: payload });
    }
    case hydrateSlice.toString(): {
      const newState = hydrate(state, payload);
      if (state.language !== newState.language) changeLanguage(newState.language);
      return newState;
    }
    default:
      return state;
  }
};
